import { render, staticRenderFns } from "./AddRole.vue?vue&type=template&id=2ac4c9b6&scoped=true"
import script from "./AddRole.vue?vue&type=script&lang=js"
export * from "./AddRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4c9b6",
  null
  
)

export default component.exports